import { DEFAULT_APP_LOCALE } from '@/@core/constants/i18n';
import { Locale } from '@/stores/useWorkspaceStore';

/**
 * Detects the initial locale based on browser language.
 * Returns 'en' or 'de' if browser language matches, otherwise falls back to 'de'.
 */
export const getInitialLocale = (): Locale => {
  const browserLang = navigator.language?.toLowerCase();

  // Extract language code (remove region code if present, e.g., 'en-US' -> 'en')
  const langCode = browserLang?.split('-')[0];

  if (langCode === 'en' || langCode === 'de') {
    return langCode;
  }

  return DEFAULT_APP_LOCALE;
};
